export function getApiErrorMessage(err, fallback) {
    const data = err.response?.data;
    if (!data) return fallback;

    if (data.message) return data.message;

    const detalle = data.detalle;
    if (detalle) {
        if (detalle.formErrors?.length) return detalle.formErrors[0];
        for (const messages of Object.values(detalle.fieldErrors ?? {})) {
            if (messages?.length) return messages[0];
        }
        return 'Datos inválidos';
    }

    return fallback;
}
